import type { MapMode } from "./map/CanvasMap";
import { utcClock } from "./format";

export function TopBar({
  mode,
  onMode,
  now,
  streamOpen,
  shipsLive,
  allTrails,
  onAllTrails,
}: {
  mode: MapMode;
  onMode: (mode: MapMode) => void;
  now: Date;
  streamOpen: boolean;
  shipsLive: number;
  allTrails: boolean;
  onAllTrails: (on: boolean) => void;
}) {
  return (
    <div id="topbar">
      <div id="brand" className="glass">
        <span className="name">
          HARBOR<em>CLOCK</em>
        </span>
        <span className="sub">cruise schedule intelligence</span>
      </div>
      <div className="spacer" />
      <button
        id="trailtoggle"
        className={`glass ${allTrails ? "on" : ""}`}
        aria-pressed={allTrails}
        onClick={() => onAllTrails(!allTrails)}
        title={
          allTrails
            ? "Showing the last 2 hours of track for every moving ship. Click to show only the followed ship's track."
            : "Showing the followed ship's track. Click to show the last 2 hours of track for every moving ship."
        }
      >
        <span className="swatch" />
        TRAILS: {allTrails ? "ALL MOVING" : "FOLLOWED"}
      </button>
      <div id="modeswitch" className={`glass ${mode === "ops" ? "ops" : ""}`}>
        <div className="knob" />
        <button className={mode === "cruise" ? "on" : undefined} onClick={() => onMode("cruise")}>
          CRUISE MODE
        </button>
        <button className={mode === "ops" ? "on" : undefined} onClick={() => onMode("ops")}>
          OPS MODE
        </button>
      </div>
      <div id="clock" className="glass" title={streamOpen ? "Live position stream connected" : "Live stream disconnected"}>
        <span className={`livedot ${streamOpen ? "" : "off"}`} />
        <span>{utcClock(now)}</span>
        <span className="feed faint">AIS · {shipsLive} SHIPS LIVE</span>
      </div>
    </div>
  );
}
